const SupportSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">💬 Hỗ Trợ và Phản Hồi</h2>
            <p className="text-slate-700">
                Gửi câu hỏi, yêu cầu hỗ trợ hoặc phản hồi về hệ thống.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Cách gửi yêu cầu hỗ trợ:</h3>
                <ol className="list-decimal list-inside space-y-3 text-slate-700">
                    <li>Vào menu <strong>"Hỗ trợ"</strong> (chỉ dành cho học sinh)</li>
                    <li>Nhập tiêu đề và nội dung câu hỏi/vấn đề</li>
                    <li>Nhấn <strong>"Gửi phản hồi"</strong></li>
                    <li>Giáo viên sẽ trả lời trong mục phản hồi của bạn</li>
                    <li>Bạn sẽ nhận được thông báo khi có phản hồi mới</li>
                </ol>
            </div>

            <div className="bg-blue-50 p-6 rounded-lg border border-blue-200">
                <h3 className="text-lg font-semibold text-blue-900 mb-2">📝 Nội dung nên hỏi</h3>
                <ul className="text-slate-700 space-y-2">
                    <li>• Thắc mắc về bài học, bài tập</li>
                    <li>• Vấn đề kỹ thuật (không vào được hệ thống, lỗi hiển thị...)</li>
                    <li>• Thắc mắc về học phí, lịch học</li>
                    <li>• Đề xuất cải thiện hệ thống</li>
                </ul>
            </div>

            <div className="bg-purple-50 p-6 rounded-lg border border-purple-200">
                <h3 className="text-lg font-semibold text-purple-900 mb-2">💬 Nhắn tin trực tiếp</h3>
                <p className="text-slate-700">
                    Trong trang chi tiết lớp học, bạn có thể nhắn tin trực tiếp với giáo viên
                    và các bạn học để trao đổi nhanh về bài học.
                </p>
            </div>
        </div>
    );
};

export default SupportSection;
